var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import React, { Component } from "react";
import * as PropTypes from "prop-types";
import { FormattedMessage, injectIntl } from "@irati/utils/lang";
import id from "@irati/utils/id";
import { walletTracking } from "@irati-tracking/wallet";
import trackingTenantWallet from "@irati-tracking/wallet/tenantWallet";
import trackingRewardWallet from "@irati-tracking/wallet/rewardWallet";
import WalletActions from "@irati/wallet/store/actions/Wallet";
import notify from "@irati/utils/notify";
import { connect } from "@irati/store";
import tracking from "@irati-tracking/platform";
import authentication from "@irati/auth";
import RewardWalletBalanceQuery from "@irati/wallet/apollo/query/RewardWallet";
import TenantWalletBalanceQuery from "@irati/wallet/apollo/query/TenantWallet";
import Link, { RouterLink } from "@irati/ui/src/Link";
import { IconTypes } from "@irati/ui/src/Icon";
import UserMenuContext from "../../../shared/UserMenuContext";
import { OptionIcon, Hr } from "../../../styled";
import WalletLink from "../../../shared/WalletLink";
var MenuContext = /** @class */ (function (_super) {
    __extends(MenuContext, _super);
    function MenuContext() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            height: 0,
            showWallet: false
        };
        return _this;
    }
    MenuContext.prototype.componentDidMount = function () {
        var _a = this.context, apps = _a.apps, appPath = _a.appPath;
        var PERKS = apps.PERKS, INSIGHTS = apps.INSIGHTS, RECOGNITION = apps.RECOGNITION, HOME = apps.HOME;
        var showWallet = !!([PERKS, INSIGHTS, RECOGNITION, HOME].includes(appPath) && authentication.apps("wallet.users"));
        this.setState({ showWallet: showWallet });
        if (showWallet) {
            var _b = this.props, requested = _b.wallet.requested, getWallet = _b.getWallet, formatMessage_1 = _b.formatMessage;
            if (!requested) {
                getWallet().catch(function () {
                    notify.error({ message: formatMessage_1({ id: "platform.nav.wallet.get.error" }), position: "top-right" });
                });
            }
        }
    };
    MenuContext.prototype.render = function () {
        var _a = this.props, formatMessage = _a.formatMessage, wallet = _a.wallet;
        var showWallet = this.state.showWallet;
        var _b = this.context, apps = _b.apps, appPath = _b.appPath;
        var idNamespace = id("user-menu", this.props);
        var ACCOUNT = apps.ACCOUNT, PLATFORM = apps.PLATFORM;
        var showRewardWallet = authentication.apps("wallet.rewardWallet");
        var showTenantWallet = authentication.apps("wallet.tenantWallet");
        var tenantName = authentication.userTenant().public_name;
        return (React.createElement(React.Fragment, null,
            React.createElement(UserMenuContext, { id: idNamespace }),
            React.createElement(Hr, null),
            showWallet && (React.createElement(WalletLink, { id: id("link-wallet", idNamespace), onClick: function () { return walletTracking.clickWalletBalance(wallet.availableBalance, wallet.currency); }, text: "platform.nav.wallet.mobile.text", to: "/", useIcon: true, wallet: wallet })),
            showRewardWallet && (React.createElement(RewardWalletBalanceQuery, { useLoader: false }, function (_a) {
                var data = _a.data;
                return (React.createElement(WalletLink, { id: id("link-reward-wallet", idNamespace), onClick: trackingRewardWallet.clickRewardWallet, text: "platform.nav.wallet.reward.mobile.text", to: "/reward", useIcon: true, wallet: data.rewardWallet }));
            })),
            showTenantWallet && (React.createElement(TenantWalletBalanceQuery, { useLoader: false }, function (_a) {
                var data = _a.data;
                return (React.createElement(WalletLink, { id: id("link-tenant-wallet", idNamespace), onClick: trackingTenantWallet.clickTenantWallet, text: "platform.nav.wallet.tenant.mobile.text", tenantName: tenantName, to: "/tenant", useIcon: true, wallet: data.tenantWallet }));
            })),
            appPath !== ACCOUNT && (React.createElement(React.Fragment, null,
                React.createElement(RouterLink, { plain: true, id: id("link-profile", idNamespace), to: "/", onClick: function () { return tracking.clickHeaderMyAccount({ source: window.location.href }); }, app: ACCOUNT },
                    React.createElement(OptionIcon, { icon: IconTypes.profile, size: 24 }),
                    React.createElement(FormattedMessage, { id: "platform.userMenu.header.account" })),
                React.createElement(Link, { id: id("link-help", idNamespace), target: "_blank", plain: true, href: formatMessage({ id: "platform.help.header.href" }) },
                    React.createElement(OptionIcon, { icon: "help", size: 24 }),
                    React.createElement(FormattedMessage, { id: "platform.help.header.text" })))),
            React.createElement(RouterLink, { id: id("link-logout", idNamespace), plain: true, to: "/welcome/logout", app: PLATFORM },
                React.createElement(OptionIcon, { icon: "logout", size: 24 }),
                React.createElement(FormattedMessage, { id: "platform.userMenu.link.logout" }))));
    };
    MenuContext.contextTypes = {
        apps: PropTypes.object.isRequired,
        appPath: PropTypes.string.isRequired
    };
    return MenuContext;
}(Component));
var mapStateToProps = function (_a) {
    var wallet = _a.wallet;
    return ({ wallet: wallet });
};
var mapDispatchToProps = function (dispatch) {
    return {
        getWallet: function () { return dispatch(WalletActions.get()); }
    };
};
export default injectIntl(connect(mapStateToProps, mapDispatchToProps)(MenuContext));
